const EncounterCardStyle = () => {
	return {
		accept_reject_box: {
			display: 'flex',
			flexDirection: 'row',
			gap: '1px',
			marginTop: '2px'
		},
		accept_reject_form: {
			width: '100px',
			height: '50px'
		},
		accept_reject_input: {
			backgroundColor: "#fff",
			width: '190px'
		},
		accept_reject_button: {
			fontSize: '10px',
			fontWeight: '600',
			padding: '1px 7px',
			maxWidth: '50px',
			marginLeft: '5px'
		},
		accept_accordion: {
			color: '#1a1a1a',
			background: 'white',
			marginTop: '16px',
			borderRadius: '12px',
			border: '1px solid #dcfce7',
			boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
			overflow: 'hidden',
			'&:hover': {
				boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
				borderColor: '#bbf7d0',
			},
			'&:before': {
				display: 'none'
			},
		},
		reject_accordion: {
			background: 'white',
			color: '#1a1a1a',
			marginTop: '16px',
			borderRadius: '12px',
			border: '1px solid #fee2e2',
			boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
			overflow: 'hidden',
			'&:hover': {
				boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
				borderColor: '#fecaca',
			},
			'&:before': {
				display: 'none'
			},
		},
		partially_accept_accordion: {
			background: 'white',
			color: '#1a1a1a',
			marginTop: '16px',
			borderRadius: '12px',
			border: '1px solid #fde68a',
			boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
			overflow: 'hidden',
			'&:hover': {
				boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
				borderColor: '#fcd34d',
			},
			'&:before': {
				display: 'none'
			},
		},
		pending_approval_accordion: {
			background: 'white',
			color: '#1a1a1a',
			marginTop: '16px',
			borderRadius: '12px',
			border: '1px solid #e5e5e5',
			boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
			overflow: 'hidden',
			'&:hover': {
				boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
				borderColor: '#d0d0d0',
			},
			'&:before': {
				display: 'none'
			},
		},
		info_text: {
			fontWeight: '500',
			marginBottom: '5px',
			textTransform: 'capitalize',
			color: '#1E201E'
		},
		pointer_info_text: {
			cursor: 'pointer',
			display: 'inline-block',
			color: '#5272F2',
			borderBottom: '1px solid #5272F2',
			marginLeft: '10px'
		},
		encounter_accordion_header_info_box: {
			marginBottom: '10px',
			padding: '10px',
			borderRadius: '10px'
		},
		encounter_accordion_header_info_box_approved: {
			backgroundColor: '#f0fdf4'
		},
		encounter_accordion_header_info_box_rejected: {
			backgroundColor: '#fef2f2'
		},
		encounter_accordion_header_info_box_partially_approved: {
			backgroundColor: '#fef3c7'
		},
		encounter_accordion_header_info_box_pending: {
			backgroundColor: '#f5f5f5'
		},
		section_container: {
			display: 'flex',
			flexDirection: 'column',
			'@media (min-width: 960px)': {
				flexDirection: 'row',
				flexWrap: 'wrap',
				gap: '24px',
			},
		},
		section_column: {
			flex: 1,
			minWidth: '280px',
			'@media (min-width: 960px)': {
				flexBasis: 'calc(50% - 12px)',
			},
		},
		encounter_accordion_summary: {
			padding: '20px',
			height: '80px',
			'& .MuiAccordionSummary-content': {
				margin: 0
			},
		},
		encounter_accordion_summary_header: {
			display: 'grid',
			gridTemplateColumns: '90px 1fr auto auto 130px',
			gap: '12px',
			alignItems: 'center',
			width: '100%',
			'@media (max-width: 1100px)': {
				gridTemplateColumns: '90px 1fr 130px',
				gap: '10px'
			},
			'@media (max-width: 768px)': {
				gridTemplateColumns: '1fr',
				gap: '12px'
			}
		},
		encounter_accordion_summary_header_approved: {
			background: '#f0fdf4'
		},
		encounter_accordion_summary_header_rejected: {
			background: '#fef2f2'
		},
		encounter_accordion_summary_header_partial: {
			background: '#fef3c7'
		},
		encounter_accordion_summary_header_pending: {
			background: '#f5f5f5'
		},
		encounter_accordion_summary_date_box: {
			display: 'flex',
			flexDirection: 'column',
			gap: '2px',
			minWidth: '80px'
		},
		reference_id_chip: {
			fontSize: '10px',
			color: '#666',
			backgroundColor: '#f0f0f0',
			padding: '2px 6px',
			borderRadius: '3px',
			fontWeight: '500',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			maxWidth: '100px'
		},
		encounter_accordion_summary_date_icon: {
			fontSize: '20px'
		},
		encounter_accordion_summary_date_value: {
			fontSize: '15px',
			fontWeight: '600',
			color: '#1a1a1a'
		},
		encounter_accordion_summary_date_label: {
			fontSize: '11px',
			color: '#666'
		},
		encounter_accordion_summary_state_box: {
			padding: '6px 10px',
			borderRadius: '20px',
			fontSize: '11px',
			fontWeight: '600',
			textAlign: 'center',
			whiteSpace: 'nowrap'
		},
		summary_approved_state_bg: {
			backgroundColor: '#dcfce7',
			color: '#16a34a'
		},
		summary_rejected_state_bg: {
			backgroundColor: '#fee2e2',
			color: '#dc2626'
		},
		summary_partially_approved_state_bg: {
			backgroundColor: '#fde68a',
			color: '#d97706'
		},
		summary_pending_state_bg: {
			backgroundColor: '#e5e5e5',
			color: '#666'
		},
		encounter_accordion_summary_patient_box: {
			display: 'flex',
			alignItems: 'center',
			gap: '12px',
			flex: 1
		},
		patient_avatar: {
			width: '40px',
			height: '40px',
			borderRadius: '50%',
			background: 'linear-gradient(135deg, #0ea5e9 0%, #06b6d4 100%)',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			color: 'white',
			fontWeight: '600',
			fontSize: '14px',
			flexShrink: 0,
			cursor: 'pointer',
			'&:hover': {
				transform: 'scale(1.05)',
				boxShadow: '0 4px 8px rgba(6, 182, 212, 0.3)'
			}
		},
		patient_details: {
			display: 'flex',
			flexDirection: 'column',
			gap: '6px',
			flex: 1
		},
		patient_name: {
			fontSize: '14px',
			fontWeight: '600',
			color: '#1a1a1a',
			marginBottom: '2px',
			display: 'flex',
			alignItems: 'center',
			gap: '8px',
			flexWrap: 'wrap'
		},
		patient_name_link: {
			fontSize: '16px',
			cursor: 'pointer',
			display: 'inline-block',
			'&:hover': {
				color: '#0ea5e9',
				textDecoration: 'underline'
			}
		},
		reference_chip: {
			fontSize: '10px',
			color: '#666',
			backgroundColor: '#e5e5e5',
			padding: '2px 8px',
			borderRadius: '12px',
			fontWeight: '500',
			whiteSpace: 'nowrap',
			width: 'fit-content',
		},
		provider_container: {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'flex-start',
			justifyContent: 'center',
			paddingLeft: '12px',
			paddingRight: '12px',
			borderLeft: '2px solid #e5e5e5',
			minWidth: '120px',
			maxWidth: '150px',
			'@media (max-width: 1100px)': {
				display: 'none'
			}
		},
		provider_label: {
			fontSize: '10px',
			color: '#999',
			textTransform: 'uppercase',
			letterSpacing: '0.5px',
			marginBottom: '2px',
			fontWeight: '600'
		},
		provider_name: {
			fontSize: '12px',
			color: '#1a1a1a',
			fontWeight: '600',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis'
		},
		encounter_stats_container: {
			display: 'flex',
			gap: '12px',
			'@media (max-width: 1100px)': {
				display: 'none'
			}
		},
		stat_item: {
			textAlign: 'center',
			minWidth: '50px'
		},
		stat_label: {
			fontSize: '10px',
			color: '#666',
			textTransform: 'uppercase',
			letterSpacing: '0.5px',
			marginBottom: '2px'
		},
		stat_value: {
			fontSize: '15px',
			fontWeight: '700',
			color: '#1a1a1a'
		},

		medical_accordion_title: {
			fontWeight: '600',
			borderBottom: 'none',
			display: 'flex',
			alignItems: 'center',
			margin: '10px 0',
		},

		medical_accordion: {
			backgroundColor: 'white',
			borderRadius: '8px',
			marginBottom: '16px',
			overflow: 'hidden',
			border: '1px solid',
			boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
			'&:before': {
				display: 'none'
			},
		},
		medical_accordion_approved_border: {
			borderColor: '#dcfce7'
		},
		medical_accordion_rejected_border: {
			borderColor: '#fee2e2'
		},
		medical_accordion_partial_border: {
			borderColor: '#fde68a'
		},
		medical_accordion_pending_border: {
			borderColor: '#e5e5e5'
		},
		medical_accordion_summary: {
			padding: '12px 16px',
			'& .MuiAccordionSummary-content': {
				margin: 0
			},
		},
		medical_approved_accordion_summary_bg: {
			backgroundColor: '#f0fdf4'
		},
		medical_rejected_accordion_summary_bg: {
			backgroundColor: '#fef2f2'
		},
		medical_partial_accordion_summary_bg: {
			backgroundColor: '#fef3c7'
		},
		medical_pending_accordion_summary_bg: {
			backgroundColor: '#f5f5f5'
		},
		medical_summary_state_box: {
			display: 'flex',
			alignItems: 'center',
			width: '100%'
		},
		medical_summary_info_box: {
			display: 'flex',
			flexGrow: 1,
			alignItems: 'center'
		},
		medical_icon: {
			fontSize: 20,
			marginRight: 1.5,
		},
		column_box: {
			display: 'flex',
			flexDirection: 'column'
		},
		medical_code: {
			fontWeight: 700,
			fontSize: '16px',
			marginRight: '8px'
		},
		medical_approved_code_color: {
			color: '#1B5E20'
		},
		medical_rejected_code_color: {
			color: '#5f2120'
		},
		medical_primary: {
			backgroundColor: 'rgba(25, 118, 210, 0.1)',
			color: '#1976D2',
			fontWeight: '500',
			fontSize: '12px',
			height: '20px',
			marginRight: '8px',
			border: '1px solid rgba(25, 118, 210, 0.2)',
		},
		align_icd_primary: {
			display: 'flex',
			alignItems: 'baseline'
		},
		mediacl_description: {
			fontWeight: 400,
			fontSize: '14px',
		},
		mediacl_description_approved_color: {
			color: '#2E7D32'
		},
		mediacl_description_rejected_color: {
			color: '#743a38'
		},
		medical_accordion_details: {
			padding: '16px'
		},
		medical_details_box: {
			marginBottom: '16px',
			backgroundColor: 'white',
			borderRadius: '6px',
			overflow: 'hidden',
			boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
		},
		medical_details_title_box: {
			display: 'flex',
			alignItems: 'center',
			backgroundColor: 'rgba(0, 0, 0, 0.04)',
			padding: '8px 12px',
			borderBottom: '1px solid rgba(0, 0, 0, 0.09)',
		},
		medical_info_title: {
			fontSize: '13px',
			fontWeight: '600',
			color: '#424242',
			textTransform: 'uppercase',
			letterSpacing: '0.5px'
		},
		medical_info_value_box: {
			display: 'grid',
			gridTemplateColumns: {
				xs: '1fr',
				sm: 'repeat(4, 1fr)'
			},
			gap: '12px',
			padding: '12px 16px'
		},
		info_value_box: {
			gap: '12px',
			padding: '12px 16px'
		},
		medical_info_value_label: {
			fontSize: '12px',
			fontWeight: '500',
			color: '#757575',
			marginBottom: '4px'
		},
		medical_info_value_values: {
			fontSize: '14px',
			fontWeight: '500',
		},

		infoCard: {
			marginBottom: '16px',
			backgroundColor: 'white',
			borderRadius: '6px',
			overflow: 'hidden',
			boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
		},
		cardHeader: {
			backgroundColor: 'rgba(0, 0, 0, 0.04)',
			padding: '8px 12px',
			borderBottom: '1px solid rgba(0, 0, 0, 0.09)',
		},
		cardHeaderText: {
			fontSize: '13px',
			fontWeight: '600',
			color: '#424242',
			textTransform: 'uppercase',
			letterSpacing: '0.5px',
		},
		infoGrid: {
			display: 'grid',
			gridTemplateColumns: {
				xs: '1fr',
				sm: 'repeat(4, 1fr)'
			},
			gap: '12px',
			padding: '12px 16px',
		},
		infoGridPrescription: {
			display: 'grid',
			gridTemplateColumns: {
				xs: '1fr',
				sm: 'repeat(3, 1fr)'
			},
			gap: '12px',
			padding: '12px 16px',
		},
		infoItem: {
			display: 'flex',
			flexDirection: 'column',
		},
		label: {
			fontSize: '14px',
			fontWeight: '550',
			color: 'black',
			marginBottom: '4px',
		},
		value: {
			fontSize: '14px',
			fontWeight: '500',
			color: '#212121',
		},
		quantityCard: {
			marginBottom: '12px',
			backgroundColor: 'white',
			borderRadius: '6px',
			overflow: 'hidden',
			boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
		},
		encounter_title: {
			fontWeight: '500',
			color: '#1E201E'
		},
		notes_container: {
			marginTop: '16px',
			padding: '16px',
			backgroundColor: '#fafafa',
			borderRadius: '8px',
			border: '1px solid #e5e5e5'
		},
		notes_header: {
			display: 'flex',
			alignItems: 'center',
			gap: '8px',
			marginBottom: '12px'
		},
		notes_title: {
			fontSize: '14px',
			fontWeight: '600',
			color: '#1a1a1a',
			textTransform: 'uppercase',
			letterSpacing: '0.5px'
		},
		notes_content: {
			fontSize: '14px',
			fontWeight: '400',
			color: '#424242',
			lineHeight: '1.6'
		},


		dot_icon: {
			fontSize: '14px',
			marginRight: '4px',
		},
		check_icon: {
			fontSize: '22px',
			marginRight: '4px',
			color: 'green'
		},
		close_icon: {
			fontSize: '22px',
			marginRight: '4px',
			color: 'red'
		},
		medicalCode_dot_icon: {
			fontSize: '8px',
			marginRight: '4px',
		},

		medicalCode_message_title: {
			paddingLeft: '0px',
			color: '#1E201E',
			fontWeight: '500',
			marginLeft: '5px'
		},
		medicalCode_message: {
			fontWeight: '450'
		},

		medicalCode: {
			fontWeight: '500'
		},
		medicalCode_messages_point: {
			display: 'flex',
			alignItems: 'center',
			marginLeft: '6px',
			marginBottom: '10px'
		},
		circular: {
			position: 'absolute',
			top: '50%',
			left: '50%',
			transform: 'translate(-50%, -50%)'
		},
		accepted_reload: {
			color: '#006400'
		},
		partially_accept_reload: {
			color: '#333333'
		},
		rejected_reload: {
			color: '#800000'
		},
		error_msg: {
			color: 'red'
		},

		drug_info: {
			fontWeight: '430',
			marginRight: '10px'
		},
		reloadBox: {
			display: 'flex',
			justifyContent: 'flex-end',
			marginTop: '10px'
		},
		reloadBtn: {
			backgroundColor: 'red',
			color: 'white',
			padding: '4px 12px',
			margin: '0 10px',
			borderRadius: '4px',
			cursor: 'pointer',
			letterSpacing: '1.5px',
			display: 'flex'
		},
		reloadIcon: {
			fontSize: '20px',
			marginRight: '5px'
		},
		btn_accepted_reload: {
			backgroundColor: '#074173'
		},
		btn_partially_accept_reload: {
			backgroundColor: '#333333'
		},
		btn_rejected_reload: {
			backgroundColor: '#800000'
		},
		insurance_save_button: {
			float: 'left',
			fontSize: '10px',
			fontWeight: '600',
			backgroundColor: 'grey',
			margin: '10px 7px',
			maxWidth: '50px'
		},
		icd_cpt_drug_messages_container: {width: '100%', borderLeft: `4px solid`, borderRadius: '8px'},
		messages_content_box: {width: '100%'},
		icd_cpt_drug_message: {borderLeft: `3px solid`, color: 'black', fontWeight: '450', paddingLeft: '5px'},
		severity_level_icon: {color: 'black'},
		severity_level_message: {color: 'black', fontWeight: '450'},
		message_icon: {fontSize: '22px'}
	};
};

export default EncounterCardStyle;